import styled from "styled-components/macro"
import Color from "../../../constants/Color"

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 12px 0;

  @media (min-width: 640px) {
    padding: 18px 0;
  }
`

export const Title = styled.h2`
  font-size: 18px;
  color: ${Color.gray800};
  margin-right: 12px;
  margin-left: 16px;

  @media (min-width: 640px) {
    margin-left: 0px;
  }
  @media (min-width: 1280px) {
    font-size: 24px;
    margin-right: 18px;
  }
`

export const Body = styled.div`
  width: 100%;
  height: 100%;
  padding: 12px 16px;
  display: grid;
  grid-template-columns: repeat(6, minmax(100px, 1fr));
  grid-gap: 16px;
  position: relative;

  @media (min-width: 640px) {
    padding: 18px 0px;
  }

  @media screen and (max-width: 1280px) {
    grid-template-columns: repeat(6, minmax(100px, 1fr));
  }

  @media screen and (max-width: 1024px) {
    grid-template-columns: repeat(4, minmax(100px, 1fr));
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(3, minmax(100px, 1fr));
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }

  @media screen and (max-width: 375px) {
    grid-template-columns: repeat(0, 1fr);
  }

  @media (min-width: 1280px) {
    grid-gap: 32px;
  }
`

export const More = styled.div`
  width: 100%;
  padding: 12px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`
